var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_12441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99449 21.7507C17.0489 21.7507 22.0026 14.2474 22.0026 7.74259C22.0026 7.53166 21.9979 7.31603 21.9886 7.10509C22.9522 6.40819 23.7838 5.54499 24.4443 4.55603C23.5469 4.95533 22.594 5.21611 21.6182 5.32947C22.6456 4.71364 23.4149 3.7462 23.7834 2.6065C22.8169 3.17929 21.7599 3.58334 20.6578 3.80134C19.9152 3.01229 18.9333 2.48985 17.864 2.31478C16.7947 2.13972 15.6975 2.32178 14.7421 2.83283C13.7866 3.34387 13.0261 4.15544 12.5782 5.14204C12.1302 6.12865 12.0198 7.23535 12.2639 8.29103C10.3068 8.19282 8.39227 7.68444 6.64432 6.79883C4.89636 5.91323 3.35403 4.67017 2.1173 3.15025C1.48874 4.23398 1.29639 5.51638 1.57937 6.73682C1.86234 7.95727 2.5994 9.02418 3.64074 9.72072C2.85896 9.6959 2.09431 9.48541 1.40996 9.10666V9.16759C1.40926 10.3049 1.80243 11.4073 2.52265 12.2875C3.24286 13.1677 4.24566 13.7713 5.36059 13.9957C4.63639 14.1939 3.87632 14.2227 3.13918 14.0801C3.45379 15.0582 4.06591 15.9136 4.89011 16.5271C5.7143 17.1405 6.70946 17.4813 7.73668 17.502C5.99276 18.8718 3.83851 19.6149 1.6209 19.6113C1.22762 19.6107 0.834735 19.5866 0.444336 19.5392C2.69719 20.9845 5.31787 21.7521 7.99449 21.7507Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_12441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.444336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.82dc04f7e8c742524968c9f3e8d27792.svg";
export { ForwardRef as ReactComponent };